import React, { Component } from "react";
import AuthLayout from "./authLayout.js"
import SimpleReactValidator from 'simple-react-validator';
import service from '../services'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'
import queryString from "query-string";
import Loader from "../component/loader.js";
import ViewIcon from './../icons/viewIcon';
import ShowPasswordIcon from './../icons/ShowPassIcon';

let setToken = '';
let sub;
const mapStateToProps = state => ({
    setToken: state.setToken
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class Resigster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            confirmPassword: "",
            token: "",
            role: "",
            loaderFlag: false,
            passShow: false,
            confirmPassShow: false

        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();

    }

    componentDidMount = () => {
        const param = new URLSearchParams(this.props.location.search);
        this.setState({
            token : param.get('token'),
            email : param.get('email'),
            role : param.get('role')
        })
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "getUser":
                    this.props.ProfileName(response.data)
                    if (response.data.additionalRoles.includes("sio") || response.data.additionalRoles.includes("press") || response.data.additionalRoles.includes("sundanceGuest") || response.data.additionalRoles.includes("general") || response.data.additionalRoles.includes("artist")) {
                        this.props.history.push('/admin-dashboard')
                    } else if (response.data.role === "partner") {
                        this.props.history.push('/profile-partner-view')
                    } else if (response.data.role === "satellite") {
                        this.props.history.push('/profile-satellite-view')
                    } else if (response.data.role === "privateScreeningPartner") {
                        if (this.state.mount)
                            this.props.history.push('/partners-film-view')
                        else this.setState({ mount: true });
                    }
                    else {
                        this.props.history.push('/access-management')
                    }
                    break;
                case "registerUser":
                    if (!response.data.token) {
                        this.setState({ loaderFlag: false })
                    }
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        }, () => {
            this.validate()
        });
    }

    registerUser = () => {
        this.apiserve.sendevent("registerUser", {
            email: this.state.email,
            password: this.state.password,
            token: this.state.token,
            role: this.state.role
        });
    }

    validate = () => {
        let emailErr = ''
        let passwordErr = '';
        let passwordMustSameError = ''
        if (!this.state.password) {
            passwordErr = 'Password can not be blank'
        }
        else {
            if (!this.state.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
                passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
            }
        }
        if (!this.state.confirmPassword) {
            passwordMustSameError = 'Confirm Password can not be blank'
        } else {
            if (this.state.password !== this.state.confirmPassword) {
                passwordMustSameError = 'Password and Confirm Password do not match'
            }
        }



        if (!this.state.email) {
            emailErr = 'This field is required.'
        } else {
            if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                emailErr = 'Email address must be valid email.';
            }

        }


        this.setState({
            passwordErr, emailErr, passwordMustSameError
        })
        if (passwordErr || emailErr || passwordMustSameError) {
            return false
        }
        return true
    }


    submitFn = (e) => {
        e.preventDefault();
        const isValid = this.validate()
        if (isValid) {
            this.setState({
                loaderFlag: true,
            });
            this.registerUser()
            // let data = {
            //     value: {
            //       email: this.state.email,
            //       password: this.state.password,
            //       token:this.state.token
            //     },
            //     api: "/register",
            //     headers: {
            //         Authorization: setToken,
            //     },
            //   };
            //   this.apiserve
            //     .postApi(data)
            //     .then((res) => {                 
            //         setTimeout(()=>{
            //             this.setState({loaderFlag:false})
            //             if(res.data.user.role === "sio" || res.data.user.role === "press" || res.data.user.role === "sundanceCircle"){
            //                 this.props.history.push('/admin-dashboard')                   
            //             }else if(res.data.user.role === "partner"){
            //                 // this.props.GetPartner(data)
            //                 this.props.history.push('/profile-partner-view')                   
            //             }else{
            //                 this.props.history.push('/access-management')                   
            //             }   
            //         },0)
            //     })
            //     .catch((error) => {
            //       if (error.response) {
            //         setTimeout(() => {
            //         this.setState({
            //             loaderFlag: false
            //           },() => this.apiserve.error(error.response.data.errors.msg));
            //       }, 3000); 
            //      }
            //     });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    Showpassword = () => {
        this.setState({
            passShow: !this.state.passShow
        })
    }
    ConfirmShowpassword = () => {
        this.setState({
            confirmPassShow: !this.state.confirmPassShow
        })
    }

    clearFn = () => {
        this.setState({
            password: "",
            confirmPassword: "",
        });
    };

    render() {
        return (
            <AuthLayout>
                {/* Box Design Start here */}
                <div className="box_wrapper signUp_box_Wrapper">
                    <h2>Sign Up</h2>
                    <form onSubmit={() => this.submitFn()}>
                        <div>
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                disabled
                                maxLength={255}
                                value={this.state.email}
                                onChange={this.onInputChange}
                            />
                            <span style={{ color: 'red' }}>{this.state.emailErr}</span>

                        </div>
                        <div>
                            <label>Password</label>
                            <div className="relative mb_0">
                                <input
                                    type={this.state.passShow ? "text" : "password"}
                                    name="password"
                                    id="password"
                                    value={this.state.password}
                                    onChange={this.onInputChange}
                                />
                                <span className="eye_icon" onClick={this.Showpassword}> {this.state.passShow ? <ShowPasswordIcon /> : <ViewIcon />} </span>
                            </div>
                            <span style={{ color: 'red' }} className='srv-validation-message'>{this.state.passwordErr}</span>
                            {this.state.passwordErr ? '' :
                                <p className="suggession_text">Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.</p>
                            }
                        </div>
                        <div>
                            <label>Confirm Password</label>
                            <div className="relative mb_0">
                                <input
                                    type={this.state.confirmPassShow ? "text" : "password"}
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    value={this.state.confirmPassword}
                                    onChange={this.onInputChange}
                                />
                                <span className="eye_icon" onClick={this.ConfirmShowpassword}> {this.state.confirmPassShow ? <ShowPasswordIcon /> : <ViewIcon />} </span>
                            </div>
                            {/* <span style={{ color: 'red' }}>{this.validator.message('confirm_password', this.state.confirmPassword, `required|in:${this.state.password}`, {messages: {in: 'Password and Confirm Password does not match.'}})}</span> */}
                            <span style={{ color: 'red' }} className='srv-validation-message'>{this.state.passwordMustSameError}</span>
                        </div>
                        <div>
                            <button
                                className="grayBTN"
                                type="button"
                                onClick={() => this.clearFn()}
                            >Clear</button>
                            <button
                                className="orangeBTN"
                                type="submit"
                                onClick={(e) => this.submitFn(e)}
                            >Submit</button>

                        </div>
                    </form>
                </div>
                {/* Box Design End's here */}

                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}

            </AuthLayout>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Resigster)